export default __webpack_public_path__ + "static/media/prev-MDS-5.def45dcd.png";